<template>
    <div class="modal" style="margin-top:50px;background:rgba(0,0,0,0.5);z-index:9999999;position:absolute;top:-50px;" :style="{display:show?'block':'none'}">
        <div style="position:relative;background:white;width:300px;height:400px;margin:0 auto;border-radius:10px;padding:10px;margin-top:20px;">

            <div class="col-xs-12">
                <span style="font-size:1.5em;">{{lang.login.login}}:</span> 
                <span type="button" @click="cancelClicked" class="btn btn-default glyphicon glyphicon-remove" style="float:right;"></span>
            </div>
            <div class="col-xs-12" style="margin-top:10px;"><input name="login-name" v-model="loginInfo.name" type="text" :placeholder="lang.login.email" class="form-control" /> </div>
            <div class="col-xs-12"><input name="login-password" v-model="loginInfo.password" type="password" :placeholder="lang.login.password" class="form-control" /></div>
            <div class="col-xs-12" style="text-align:right;margin-top:10px;">
                <span class="btn btn-default"  style="float:left;" @click="goRegister">{{lang.login.register}}</span>
                <input type="button" @click="login" class="btn btn-default" :value="lang.login.login" />
            </div>
            <div class="col-xs-12">
                <ext-login-buttons></ext-login-buttons>
            </div>
            <div class="col-xs-12" style="color:red;text-align:center;">{{loginMsg}}</div>
            <div style="position:absolute;width:100%;left:0px;bottom:10px;text-align:center;margin-top:10px;">
                <span style="border-bottom:1px solid #1fa4fc;cursor:pointer;" @click="forgotLogin">{{lang.login.forgotAccountPassword}}</span>
            </div>
        </div>
    </div>
</template>
<script>
    import ExtLoginButtons from './ExtLoginButtons.vue';

    export default {
        components: {
            ExtLoginButtons: ExtLoginButtons,
        },
        props: {
            "show": { type: Boolean, default: false }
            },
        data: function () {
            return {
                loginMsg: null,
                loginInfo: { name: null, password: null }
            }
        },
        computed: {
            apiClient: function () {
                return this.mxnAgxApi.apiClient;
            },
            lang: function () {
                return this.$store.getters.lang;
            }
        },
        methods: {
            forgotLogin: function () {
                this.cancelClicked();
                this.$router.push({ path:"/ForgotLogin" });
            },
            goRegister: function () {
                this.cancelClicked();
                this.$router.push({ path: "/Register" });
            },
            cancelClicked: function () {
                console.log('emit cancel!');
                this.$emit("oncancel");
            },
            login: function () {
                this.loginMsg = "";
                var info = {
                    id: this.loginInfo.name, password: this.loginInfo.password
                };
                this.apiClient.loginPrms(info).done((e)=> {
                    if (e.ok === true) {
                        this.$store.commit("setShowLogin", false);
                        this.$store.commit("setAccount", e.value);
                        this.loginInfo.name = "";
                        this.loginInfo.password = "";

                        /* expose event to parent*/
                        this.$emit("onlogin",e);

                    } else {
                        this.loginMsg = "Login Failed";
                        this.loginInfo.password = "";
                    }
                });
            },
        },
        mounted: function () {

        }
    }
</script>